export const invoiceType = (
  isExpense: boolean,
  totalAmountCents: number | string
): 'debit' | 'credit' => {
  const amount = Number(totalAmountCents)
  if (isExpense) {
    return amount > 0 ? 'debit' : 'credit'
  } else {
    return amount > 0 ? 'credit' : 'debit'
  }
}
